import {
  requestConnectShopeeChatURL,
  requestConnectShopeeURL,
  requestLazadaChatURL,
  requestLazadaURL,
  requestTiktokChatUrl,
  requestTiktokUrl,
} from "src/api/server/marketplace";
import { disconnectMarketplaceChannel } from "src/api/server/account";
import type { MarketplaceAccount, MarketplaceChannel } from "../types/marketplaceAccount";

function openUrl(url?: string) {
  if (!url) throw new Error("Marketplace authorization URL was not returned");
  window.open(url, "_blank", "noopener,noreferrer");
}

export async function openMarketplaceReconnect(account: MarketplaceAccount, channel: MarketplaceChannel) {
  const reconnectChat = channel === "chat";

  if (account.type === "shopee") {
    const result = reconnectChat
      ? await requestConnectShopeeChatURL(account.id)
      : await requestConnectShopeeURL(account.id);
    openUrl(result?.url);
    return;
  }

  if (account.type === "lazada") {
    const result = reconnectChat
      ? await requestLazadaChatURL("Lazada", account.id)
      : await requestLazadaURL("Lazada", account.id);
    openUrl(result?.login_url);
    return;
  }

  if (account.type === "tiktok") {
    const result = reconnectChat
      ? await requestTiktokChatUrl("Tiktok_Chat")
      : await requestTiktokUrl("Tiktok_Shop");
    openUrl(result?.url);
    return;
  }

  throw new Error(`Reconnect is not available for ${account.type}`);
}

export async function disconnectMarketplaceConnection(account: MarketplaceAccount, channel: MarketplaceChannel) {
  return disconnectMarketplaceChannel(account.id, channel);
}
